<!-- 页头 -->
<template>
  <header class="PageHead-Component">
    <div class="head-left">
      <div class="logo">
        <a @click="goHome">
          <img :src="require('@assets/img/logo-b.png')" alt="" />
        </a>
      </div>
      <ul class="nav">
        <li v-for="(item, index) in navList" :key="index">
          <nuxt-link
            :to="localePath(item.url)"
            :class="{ active: index === activeTab }"
          >
            {{ $t(item.name) }}
          </nuxt-link>
        </li>
      </ul>
    </div>
    <div class="head-right">
      <ul class="head-right__tools">
        <li>
          <a class="hover-blue" href="javascript:;" @click="handleVideoStudio">
            {{ $t('lang035') }}
          </a>
        </li>
        <li class="head-right__tool-app" @mouseover="firstIn = false">
          <a
            class="hover-blue icon-arrow"
            target="_blank"
            href="/connector.html"
          >
            {{ $t('lang036') }}
          </a>
          <div class="load-box-transparent">
            <div class="load-box">
              <ul class="load-box__btns">
                <li v-for="(item, index) in connectorBoxList" :key="index">
                  <!-- <nuxt-link :to="localePath(item.url)" :class="item.class">{{
                    item.name
                  }}</nuxt-link> -->
                  <a :href="item.url" target="_blank" :class="item.class">{{
                    item.name
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="head-right__tool-app">
          <a
            class="hover-blue icon-arrow"
            href="javascript:;"
            @mouseover="firstIn = false"
          >
            APP
          </a>
          <div :class="['load-box-transparent', { 'load-box-block': firstIn }]">
            <div :class="['load-box']">
              <ul class="load-box__btns">
                <li v-for="(item, index) in loadBoxList" :key="index">
                  <a
                    :class="item.class"
                    target="_blank"
                    :href="item.url"
                    rel="noopener"
                    >{{ item.name }}</a
                  >
                </li>
              </ul>
              <img
                :src="require('@assets/img/code_download.png')"
                class="load-box__download-code"
              />
              <p class="load-box__tips">{{ $t('lang024') }}</p>
            </div>
          </div>
        </li>
        <li>
          <a class="hover-blue" target="_blank" href="/payment/pay/transit">{{
            $t('lang037')
          }}</a>
        </li>
        <li ref="langList" class="btn-lang" @mouseover="firstIn = false">
          <a
            class="hover-blue"
            href="javascript:;"
            @click="showLang = !showLang"
          >
            {{ $t('lang167') }}
          </a>
          <div v-if="showLang" class="lang-list">
            <a
              v-for="(lang, index) in langList"
              :key="index"
              href="javascript:;"
              :class="{ active: $i18n.locale === lang.code }"
              @click="switchLang(lang.code)"
            >
              {{ lang.name }}
            </a>
          </div>
        </li>
      </ul>
      <div
        v-if="userInfo.nick_name"
        class="head-right__logined-box"
        @mouseover="firstIn = false"
      >
        <div class="logined-box__avatar">
          <img :src="userInfo.data5 || require('@assets/img/head.png')" />
        </div>
        <div class="logined-box__nickname">{{ userInfo.nick_name }}</div>
        <!-- 个人信息悬浮框 start -->
        <div class="user-profile-fixed">
          <div class="thumb-wrap-grade">
            <div class="thumb-box">
              <img :src="userInfo.data5 || require('@assets/img/head.png')" />
            </div>
            <div class="user-grade">
              <div class="user-grade__num">{{ userInfo.level }}</div>
            </div>
          </div>
          <div class="user-profile-userinfo">
            <div class="user-profile-userinfo__nickname">
              {{ userInfo.nick_name }}
            </div>
            <div class="user-profile-userinfo__bigoid">
              Bigo ID:{{ userInfo.bigo_id }}
            </div>
          </div>
          <div class="balance-recharge">
            <div class="balance-recharge__left">
              {{ $t('lang120') }}:
              <i class="icon-diamond">
                {{ userInfo.balance }}
              </i>
            </div>
            <a
              href="/payment/pay/transit"
              class="balance-recharge__btn"
              target="_blank"
            >
              {{ $t('lang037') }}
            </a>
          </div>
          <div class="user-profile-fixed__bottom">
            <div class="btn-bottom btn-profile">
              <div class="btn-profile-before-icon"></div>
              <nuxt-link :to="localePath('/userCenter/index')">{{
                $t('lang340')
              }}</nuxt-link>
            </div>
            <div class="btn-bottom btn-logout">
              <div class="btn-profile-before-icon-logout"></div>
              <a href="javascript:;" @click="logout">{{ $t('lang134') }}</a>
            </div>
          </div>
        </div>
        <!-- 个人信息悬浮框 end -->
      </div>
      <div v-else class="head-right__login">
        <button class="head-right__login__btn" @click="openLogin">
          {{ $t('lang038') }}
        </button>
        <div v-show="showFirstIn" class="first-in">
          <button
            class="first-in__btn-close"
            @click="showFirstIn = false"
          ></button>
        </div>
      </div>
    </div>
    <login-popup v-model="loginPopUpVisible" />
    <div id="iframe_box_e"></div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import LoginPopup from '@components/LoginPopup/index';

export default {
  components: {
    LoginPopup
  },
  data() {
    this.navList = [
      {
        url: '/',
        name: 'lang032'
      },
      {
        url: '/games',
        name: 'lang033'
      },
      {
        url: '/show',
        name: 'lang034'
      }
    ];
    this.loadBoxList = [
      {
        url: 'https://itunes.apple.com/app/id1077137248',
        name: 'App Store',
        class: 'icon-appStore'
      },
      {
        url:
          'https://static-web.hzmk.site/as/bigo-static/apk/bigolive-bigotv.apk',
        name: 'Android Apk',
        class: 'icon-android'
      },
      {
        url:
          'https://static-web.hzmk.site/as/bigo-static/apk/bigolivelite-bigotv.apk',
        name: 'Lite Apk',
        class: 'icon-android'
      },
      {
        url: 'https://play.google.com/store/apps/details?id=sg.bigo.live',
        name: 'Google Play',
        class: 'icon-googlePlay'
      }
    ];
    this.langList = [
      { name: 'English', code: 'en' },
      { name: 'Bahasa Melayu', code: 'ms' }, // 马来
      { name: 'Tiếng Việt', code: 'vi' }, // 越南
      { name: '中文(简体)', code: 'cn' },
      { name: '中文（繁體）', code: 'tw' },
      { name: 'ไทย', code: 'th' }, // 泰国
      { name: 'Türkçe', code: 'tr' }, // 土耳其
      { name: 'عربى', code: 'ar' }, // 沙特
      { name: 'bahasa Indonesia', code: 'id' }, // 印度尼西亚
      { name: 'français', code: 'fr' }, // 法国
      { name: 'русский', code: 'ru' }, // 俄罗斯
      { name: 'Deutsch', code: 'de' }, // 德国
      { name: 'italiano', code: 'it' }, // 意大利
      { name: 'Español', code: 'es' }, // 西语
      { name: 'Polskie', code: 'pl' }, // 波兰
      { name: 'Nederlands', code: 'nl' }, // 荷兰
      { name: 'हिंदी', code: 'hi' }, // 印地
      { name: '日本語', code: 'ja' },
      { name: '한국어', code: 'ko' },
      { name: 'Português', code: 'pt' }, // 葡语
      { name: 'svenska', code: 'se' }, // 瑞典
      { name: 'Română', code: 'ro' }, // 罗马尼亚
      { name: 'ဗမာ', code: 'mm' } // 缅甸
    ];
    return {
      loginPopUpVisible: false,
      activeTab: 0,
      showFirstIn: false,
      showLang: false,
      firstIn: true,
      connectorBoxList: []
    };
  },
  computed: {
    ...mapState(['userInfo', 'videoType'])
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        const routeName = this.getRouteBaseName();
        let activeTab = 0;
        if (this.videoType === 1) {
          activeTab = 2;
        } else {
          activeTab = 1;
        }
        if (['index', 'userCenter'].includes(routeName)) {
          activeTab = 0;
        } else if (['classify', 'games'].includes(routeName)) {
          activeTab = 1;
        } else if (['show', 'all'].includes(routeName)) {
          activeTab = 2;
        }
        this.activeTab = activeTab;
      }
    }
  },
  mounted() {
    if (localStorage && !localStorage.getItem('firstVisitLogin')) {
      this.showFirstIn = true;
      localStorage.setItem('firstVisitLogin', 'visited');
    }
    document.addEventListener('click', (e) => {
      const langListDom = this.$refs.langList;
      const { target } = e;
      if (!langListDom) return;
      if (target === langListDom || langListDom.contains(target)) return;
      this.showLang = false;
    });

    if (this.$route.name.includes('userCenter')) {
      this.firstIn = false;
    } else {
      document.addEventListener('scroll', () => {
        this.firstIn = false;
      });
    }
    const baseUrl = location.origin + '/' + this.$i18n.locale;
    this.connectorBoxList = [
      {
        url: baseUrl + '/bigo-streamer',
        name: 'BIGO LIVE Streamer',
        class: 'icon-computer-new icon-new'
      },
      {
        url: baseUrl + '/bigo-streamer/connector',
        name: 'BIGO LIVE Connector',
        class: 'icon-computer'
      },
      {
        url: baseUrl + '/bigo-streamer/obs',
        name: 'OBS Stream',
        class: 'icon-obs'
      },
      {
        url: baseUrl + '/bigo-streamer/ios',
        name: 'iOS',
        class: 'icon-appStore'
      },
      {
        url: baseUrl + '/bigo-streamer/android',
        name: 'Android',
        class: 'icon-android'
      }
    ];
  },
  methods: {
    openLogin() {
      this.loginPopUpVisible = true;
    },
    async logout() {
      const res = await this.$api.logout();
      if (res && res.code === 0) {
        window.location.reload();
      } else {
        this.$log && this.$log.error('logout error', { msg: res.code });
      }
    },
    goHome() {
      this.$router.push(this.localeRoute('/'));
    },
    handleVideoStudio() {
      /* eslint-disable camelcase */
      const { nick_name, bigo_id, data5 } = this.userInfo;
      const isLogin = nick_name || bigo_id || data5;
      if (isLogin) {
        window.open('https://www.bigo.tv/video-studio/index.html', '_blank');
        return;
      }
      this.loginPopUpVisible = true;
    },
    switchLang(code) {
      this.$router.replace(this.switchLocalePath(code));
      this.showLang = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~assets/scss/mixin.scss';

.PageHead-Component {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  min-width: 1080px;
  min-height: 60px;
  z-index: 9999;
  background: #fff;
}

.head-left {
  float: left;
  position: relative;
  min-height: 60px;
  // height: 100%;
  // width: 600px;
  margin-left: 25px;
  overflow: hidden;

  .logo {
    position: relative;
    top: 8px;
    float: left;

    a {
      display: inline-block;
      width: 175.83px;
      height: 45px;

      img {
        height: 45px;
        width: 158.47px;
      }
    }
  }

  .nav {
    position: relative;
    top: 12px;
    display: inline-block;
    overflow: hidden;
    margin-left: 20px;

    li {
      float: left;
      margin-right: 10px;

      a {
        display: inline-block;
        padding: 0 20px;
        overflow: hidden;
        font-size: 16px;
        font-weight: 600;
        color: #2f3033;
        line-height: 35px;

        &:hover {
          color: #00decb;
        }

        &.active {
          color: #00decb;
        }
      }
    }
  }
}

.head-right {
  position: relative;
  padding-top: 20px;
  float: right;
  margin-right: 30px;

  .head-right__tools {
    float: left;

    li {
      float: left;
      position: relative;
      margin-left: 34px;

      a {
        font-size: 16px;
        font-weight: 500;
        color: #2f3033;
        line-height: 22px;
      }
    }

    .btn-lang {
      position: relative;

      .lang-list {
        position: absolute;
        top: 40px;
        left: -40px;
        width: 180px;
        height: 295px;
        padding: 0 10px;
        overflow-y: auto;
        background: #fff;
        border-radius: 3px;
        border: 1px #e2e2e2 solid;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          width: 0;
        }

        a {
          display: block;
          margin: 10px 0;

          &:hover {
            color: #00decb;
          }

          &.active {
            color: #00decb;
          }
        }
      }
    }
  }

  .hover-blue:hover {
    color: #00decb;
  }

  .head-right__tool-app {
    &:hover .load-box-transparent {
      display: block;
      animation: scale 0.5s;
    }

    &:hover .icon-arrow::after {
      transform: rotateZ(0);
      -webkit-transform: rotateZ(0);
      -moz-transform: rotateZ(0);
      background-image: url('~@assets/img/up_arrow_green.png');
    }

    .icon-arrow {
      position: relative;
      padding-right: 18px;

      &::after {
        position: absolute;
        top: 4px;
        right: -3px;
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-image: url('~@assets/img/up_arrow.png');
        transform: rotateZ(180deg);
        -webkit-transform: rotateZ(180deg);
        -moz-transform: rotateZ(180deg);
      }
    }
  }

  .load-box-transparent {
    display: none;
    position: absolute;
    left: -45px;
    top: 15px;
    padding-top: 30px;
    background: transparent; // 透明背景，为了让 hover 保留 block 直至鼠标移除

    .load-box {
      background: #fff;
      // border: 1px #e2e2e2 solid;
      transform-origin: 100% 0;
      border-radius: 3px;
      padding: 20px 24px;
      padding-bottom: 5px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -4px;
        left: 75px;
        width: 7px;
        height: 7px;
        // border-top: 1px #e2e2e2 solid;
        // border-left: 1px #e2e2e2 solid;
        transform: rotate(45deg);
        background: #fff;
      }

      .load-box__btns {
        li {
          white-space: nowrap;
          display: block;
          float: none;
          margin-left: 0;
          margin-bottom: 15px;
          overflow: hidden;

          a {
            font-size: 14px;
            font-weight: 500;
            color: #2f3033;
            line-height: 14px;

            &::before {
              content: '';
              display: inline-block;
              width: 20px;
              height: 20px;
              margin-right: 10px;
              vertical-align: sub;
              background-size: cover;
            }

            &:hover {
              color: #00decb;
            }
          }

          .icon-new::after {
            content: 'new';
            display: inline-block;
            width: 29px;
            text-align: center;
            height: 18px;
            margin-left: 16px;
            font-size: 10px;
            font-weight: 500;
            color: #fff;
            line-height: 18px;
            background: #ff3366;
            border-radius: 9px;
            vertical-align: top;
          }

          .icon-computer-new {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-computer-new.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-computer-new-active.png);
              }
            }
          }

          .icon-obs {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-obs.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-obs.png);
              }
            }
          }

          .icon-computer {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-computer.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-computer-active.png);
              }
            }
          }

          .icon-appStore {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-ios.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-ios-active.png);
              }
            }
          }

          .icon-android {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-android.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-android-active.png);
              }
            }
          }

          .icon-googlePlay {
            &::before {
              background-image: url(~@assets/img/bigo-streamer/icon-google.png);
            }

            &:hover {
              &::before {
                background-image: url(~@assets/img/bigo-streamer/icon-google-active.png);
              }
            }
          }
        }
      }

      &__download-code {
        position: relative;
        top: -5px;
        display: block;
        width: 124px;
        height: 124px;
        margin: auto;
        margin-bottom: 5px;
      }

      &__tips {
        width: 100%;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 1px;
        font-size: 14px;
        font-weight: 500;
        color: #8a8f99;
        line-height: 14px;
      }
    }

    &.load-box-block {
      display: block;
    }
  }

  .head-right__login {
    position: relative;
    float: left;
    margin-left: 34px;

    &__btn {
      position: relative;
      top: -6px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 12px;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      min-width: 66px;
      height: 32px;
      background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
      border-radius: 16px;
    }

    .first-in {
      position: absolute;
      width: 583px;
      height: 351px;
      top: 30px;
      right: 0;
      background: url(~@assets/img/tips_login.png) center no-repeat;

      &__btn-close {
        position: absolute;
        width: 30px;
        height: 30px;
        left: 17px;
        top: 40px;
        cursor: pointer;
      }
    }
  }

  .head-right__logined-box {
    float: right;
    position: relative;
    top: -12px;
    height: 52px;
    margin-left: 34px;
    cursor: pointer;

    &:hover .user-profile-fixed {
      display: block;
      animation: scale 0.5s;
    }

    .logined-box__avatar {
      float: left;
      width: 45px;
      height: 45px;
      margin-right: 10px;
      overflow: hidden;
      border-radius: 45px;
      box-shadow: 0px 0px 1px #000;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .logined-box__nickname {
      position: relative;
      float: right;
      height: 20px;
      max-width: 100px;
      margin-top: 12px;
      padding-right: 20px;
      line-height: 20px;
      font-size: 16px;
      color: #999;

      @include els();

      &::after {
        content: '';
        position: absolute;
        right: -1px;
        top: 6px;
        display: inline-block;
        border: 8px solid transparent;
        border-top-color: #999;
      }
    }
  }

  .user-profile-fixed {
    display: none;
    position: absolute;
    right: 0;
    top: 50px;
    width: 300px;
    height: 290px;
    background: #fff;
    border: 1px #eee solid;

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      right: 50px;
      top: -6px;
      width: 10px;
      height: 10px;
      transform: rotate(45deg);
      background: #fff;
      border-top: 1px #eee solid;
      border-left: 1px #eee solid;
    }

    .thumb-wrap-grade {
      position: relative;
      width: 80px;
      height: 82px;
      margin: auto;
      margin-top: 20px;

      .thumb-box {
        width: 80px;
        height: 80px;
        overflow: hidden;
        border-radius: 80px;

        img {
          display: block;
          width: 80px;
          height: 80px;
          border-radius: 80px;
        }
      }

      .user-grade {
        position: absolute;
        box-sizing: content-box;
        bottom: 0;
        left: 50%;
        width: 60px;
        height: 22px;
        border: 2px #fff solid;
        background: #fd809e;
        border-radius: 22px;
        margin-left: -32px;
        text-align: center;

        &__num {
          display: inline-block;
          font-size: 16px;
          color: #fff;
          line-height: 22px;

          &::before {
            content: '\e902';
            display: block;
            font-family: 'iconFont';
            float: left;
            font-size: 14px;
            margin-right: 5px;
            color: #fff99b;
          }
        }
      }
    }

    .user-profile-userinfo {
      text-align: center;
      margin: 10px auto 20px;

      &__nickname {
        height: 20px;
        font-size: 16px;
        color: #3a5161;
        line-height: 20px;
        overflow: hidden;
      }

      &__bigoid {
        font-size: 14px;
        color: #81a1ae;
      }
    }

    .balance-recharge {
      width: 280px;
      margin: auto;
      padding-top: 20px;
      border-top: 1px #eee solid;
      overflow: hidden;

      &__left {
        float: left;
        margin-top: 7px;
        font-size: 16px;
        color: #81a1ae;

        .icon-diamond {
          padding-left: 20px;
          position: relative;

          &::before {
            content: '';
            display: block;
            width: 20px;
            height: 20px;
            position: absolute;
            top: 0;
            left: 0;
            right: 14px;
            background: url(~@assets/img/icon2.png) -4px -29px no-repeat;
          }
        }
      }

      &__btn {
        float: right;
        padding: 10px 15px;
        font-size: 14px;
        color: #fff;
        background: #00decb;
        border-radius: 4px;

        &:hover {
          background: #00caba;
        }
      }
    }

    &__bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 50px;
      width: 100%;
      background: #fafafa;

      a {
        display: block;
        // line-height: 50px;
        text-align: center;
        color: #3a5161;
        font-size: 16px;
        font-weight: 500;

        &:hover {
          color: #00decb;
        }
      }

      .btn-bottom {
        float: left;
        position: relative;
        width: 50%;
        height: 100%;
      }

      .btn-profile {
        display: flex;
        justify-content: center;
        align-items: center;

        .btn-profile-before-icon {
          width: 20px;
          height: 20px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          background-image: url('~@assets/img/people-login.png');
          margin-right: 4px;
          flex-shrink: 0;
        }

        a {
          line-height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #8a8f99;
          max-width: 120px;
        }

        &::after {
          content: '|';
          position: absolute;
          right: 0;
          top: 13px;
          display: block;
          font-size: 20px;
          color: #eee;
        }
      }

      .btn-logout {
        display: flex;
        justify-content: center;
        align-items: center;

        .btn-profile-before-icon-logout {
          width: 20px;
          height: 20px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          background-image: url('~@assets/img/logout.png');
          margin-right: 4px;
          flex-shrink: 0;
        }

        a {
          line-height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #8a8f99;
          max-width: 120px;
        }
      }
    }
  }
}

// @media (max-width: 1300px) {
//   .PageHead-Component {
//     min-width: 1026px;
//   }

//   .head-left {
//     // width: 579px;
//     margin-left: 20px;

//     .nav {
//       margin-left: 0;
//     }
//   }

//   .head-right {
//     margin-right: 2px;
//   }
// }

@keyframes scale {
  0% {
    transform: scale(0.95);
  }

  25% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}
</style>
